/*
 * Hero newsletter CTA submit handler (HubSpot Forms API).
 * Delegated once at the document level, so it covers every hero newsletter
 * form on the page (and any re-rendered in the theme editor).
 *
 * Each form carries:
 *   data-hs-newsletter          (marker)
 *   data-portal-id  data-form-id  data-region
 *   data-success                (success message)
 */
(function () {
  if (window.__heroNewsletterInit) return;
  window.__heroNewsletterInit = true;

  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : '';
  }

  function endpointFor(portal, formId, region) {
    var host =
      region && region !== 'na1'
        ? 'https://api-' + region + '.hsforms.com'
        : 'https://api.hsforms.com';
    return host + '/submissions/v3/integration/submit/' + portal + '/' + formId;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-hs-newsletter]');
    if (!form) return;
    event.preventDefault();

    var portal = form.getAttribute('data-portal-id');
    var formId = form.getAttribute('data-form-id');
    var region = form.getAttribute('data-region');
    var emailInput = form.querySelector('input[type="email"]');
    var message = form.querySelector('.hero-newsletter__message');
    var button = form.querySelector('button[type="submit"]');
    var email = emailInput ? emailInput.value.trim() : '';

    function showMessage(text) {
      if (!message) return;
      message.textContent = text;
      message.hidden = false;
    }

    if (!email) {
      showMessage('Please enter your email.');
      return;
    }
    if (!portal || !formId) {
      showMessage('Newsletter is not configured yet.');
      return;
    }

    var context = {
      pageUri: window.location.href,
      pageName: document.title
    };
    var hutk = getCookie('hubspotutk');
    if (hutk) context.hutk = hutk;

    var payload = {
      fields: [{ name: 'email', value: email }],
      context: context
    };

    if (button) button.disabled = true;

    fetch(endpointFor(portal, formId, region), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { ok: res.ok, data: data };
          });
      })
      .then(function (result) {
        if (result.ok) {
          showMessage(form.getAttribute('data-success') || 'Thanks! You are in.');
          form.reset();
          var group = form.querySelector('.hero-newsletter__group');
          if (group) group.style.display = 'none';
        } else {
          showMessage('Something went wrong. Please try again.');
        }
      })
      .catch(function () {
        showMessage('Something went wrong. Please try again.');
      })
      .finally(function () {
        if (button) button.disabled = false;
      });
  });
})();
